<amplify-authenticator
  [hideSignUp]="true"
  [services]="services">
  <ng-template amplifySlot="header">
    <div style="padding: var(--amplify-space-large); text-align: center">
      <img
        class="amplify-image"
        src="assets/images/combined-logo-200x500.png"
        alt="AKlor Software Banner Image"
      />
    </div>
  </ng-template>
</amplify-authenticator>
